//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { RoutableStateName } from 'app/top-level-states';

export const TiktokAudiencePrefix = 'tiktok-audience-';
export const TikTokCalendarPrefix = 'tiktok-calendar-';
const TiktokEngagementPrefix = 'tiktok-engagement-';
export const TiktokPrefix = 'tiktok-';
const TikTokPostDetailsPrefix = 'tiktok-post-details-';
export const TiktokSummaryPrefix = 'tiktok-summary-';

export const TiktokTrackingIds = {
  POST_TIME_TOOLTIP_SETTINGS_PAGE_LINK: `${TiktokPrefix}post-time-tooltip-settings-page-link`,
};
export const TiktokAudienceTrackingIds = {
  AUDIENCE_DATE_PICKER: `${TiktokAudiencePrefix}date-picker`,
  AUDIENCE_FEEDBACK_LINK: `${TiktokAudiencePrefix}feedback-link`,
  CREATE_A_POST_BUTTON: `${TiktokAudiencePrefix}create-a-post-button`,
  SUMMARY_PDF_REPORT_DOWNLOAD_BUTTON: `${TiktokAudiencePrefix}pdf-report-download-button`,
};

export const TiktokCalendarTrackingIds = {
  CALENDAR_ACTION_MENU: `${TikTokCalendarPrefix}action-menu`,
  CREATE_A_POST_BUTTON: `${TikTokCalendarPrefix}create-a-post-button`,
};

export const TiktokEngagementTrackingIds = {
  CREATE_A_POST_BUTTON: `${TiktokEngagementPrefix}create-a-post-button`,
  ENGAGEMENT_DATE_PICKER: `${TiktokEngagementPrefix}date-picker`,
  ENGAGEMENT_PERFORMANCE_CHART_DROPDOWN: `${TiktokEngagementPrefix}performance-chart-dropdown`,
  ENGAGEMENT_MEDIA_PERFORMANCE_CSV_DOWNLOAD: `${TiktokEngagementPrefix}media-performance-csv-download`,
  ENGAGEMENT_VIEW_ORIGINAL_TIKTOK: `${TiktokEngagementPrefix}view-original-tiktok`,
  SUMMARY_PDF_REPORT_DOWNLOAD_BUTTON: `${TiktokEngagementPrefix}pdf-report-download-button`,
};

export const TiktokSummaryTrackingIds = {
  CREATE_A_POST_BUTTON: `${TiktokSummaryPrefix}create-a-post-button`,
  DELETE_SCHEDULED_TIKTOK: `${TiktokSummaryPrefix}delete-scheduled-tiktok`,
  EDIT_SCHEDULED_TIKTOK: `${TiktokSummaryPrefix}edit-scheduled-tiktok`,
  SCHEDULED_MEDIA_CARD: `${TiktokSummaryPrefix}scheduled-media-card-`,
  SUMMARY_PDF_REPORT_DOWNLOAD_BUTTON: `${TiktokSummaryPrefix}pdf-report-download-button`,
  SUMMARY_PERFORMANCE_CHART_DROPDOWN: `${TiktokSummaryPrefix}performance-chart-dropdown`,
  SUMMARY_UPCOMING_SCHEDULED_VIEW_SCHEDULE_BUTTON: `${TiktokSummaryPrefix}upcoming-scheduled-view-schedule-button`,
  SUMMARY_VIEW_ENGAGEMENT_BUTTON: `${TiktokSummaryPrefix}view-engagement-button`,
  SUMMARY_VIEW_SCHEDULE_BUTTON: `${TiktokSummaryPrefix}view-schedule-button`,
};

export const TikTokPostDetailsTrackingIds = {
  ADD_MEDIA_EMPTY_STATE_BUTTON: `${TikTokPostDetailsPrefix}add-media-empty-state-button`,
  ADD_PRODUCTS_BUTTON: `${TikTokPostDetailsPrefix}add-products-button`,
  CANCEL_SCHEDULE_BUTTON: `${TikTokPostDetailsPrefix}cancel-schedule-button`,
  COVER_IMAGE_SELECTION_MODAL: `${TikTokPostDetailsPrefix}cover-image-selection-modal`,
  COVER_IMAGE_SELECTION_MODAL_CANCEL_BUTTON: `${TikTokPostDetailsPrefix}cover-image-selection-modal`,
  COVER_IMAGE_SELECTION_MODAL_OPEN_MODAL_BUTTON: `${TikTokPostDetailsPrefix}cover-image-selection-modal`,
  COVER_IMAGE_SELECTION_MODAL_SELECT_BUTTON: `${TikTokPostDetailsPrefix}cover-image-selection-modal`,
  DATE_PICKER: `${TikTokPostDetailsPrefix}date-picker`,
  DATE_PICKER_BEST_TIMES_AND_DATE_CTA: `${TikTokPostDetailsPrefix}date-picker-best-times-and-dates-cta`,
  DATE_PICKER_BEST_TIMES_CTA: `${TikTokPostDetailsPrefix}date-picker-best-times-cta`,
  DISABLE_COMMENTS_BUTTON: `${TikTokPostDetailsPrefix}disable-comments-button`,
  DISABLE_DUETS_BUTTON: `${TikTokPostDetailsPrefix}disable-duets-button`,
  DISABLE_STITCHES_BUTTON: `${TikTokPostDetailsPrefix}disable-stitches-button`,
  MEDIA_REMOVE_ACTION_BUTTON: `${TikTokPostDetailsPrefix}media-remove-action-button`,
  MEDIA_VIEW_DETAILS_ACTION_BUTTON: `${TikTokPostDetailsPrefix}media-view-details-action-button`,
  SAVE_AS_DRAFT_BUTTON: `${TikTokPostDetailsPrefix}save-as-draft-button`,
  SCHEDULE_BUTTON: `${TikTokPostDetailsPrefix}schedule-button`,
  SMART_INPUT_CAPTION: `${TikTokPostDetailsPrefix}smart-input-caption`,
  TIME_PICKER: `${TikTokPostDetailsPrefix}time-picker`,
} as const;

export const schedulePostButtonTrackingIds: Partial<
  Record<RoutableStateName, string>
> = {
  'tiktok.audience': TiktokAudienceTrackingIds.CREATE_A_POST_BUTTON,
  'tiktok.engagement': TiktokEngagementTrackingIds.CREATE_A_POST_BUTTON,
  'tiktok.schedule.calendar': TiktokCalendarTrackingIds.CREATE_A_POST_BUTTON,
  'tiktok.summary': TiktokSummaryTrackingIds.CREATE_A_POST_BUTTON,
};

export const summaryPdfReportDownloadButtonTrackingIds: Partial<
  Record<RoutableStateName, string>
> = {
  'tiktok.audience':
    TiktokAudienceTrackingIds.SUMMARY_PDF_REPORT_DOWNLOAD_BUTTON,
  'tiktok.engagement':
    TiktokEngagementTrackingIds.SUMMARY_PDF_REPORT_DOWNLOAD_BUTTON,
  'tiktok.summary': TiktokSummaryTrackingIds.SUMMARY_PDF_REPORT_DOWNLOAD_BUTTON,
};
